module.exports = __webpack_public_path__ + "static/media/logo.deb1c316.png";